import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import PhoneShell from '../components/shared/PhoneShell';
import BackHeader from '../components/shared/BackHeader';
import { toggleBetSlip } from '../utils/betSlip';
import { maskStyle } from '../utils/icons';
import { useLang } from '../i18n';
import FavStar from '../components/shared/FavStar';

const API = process.env.REACT_APP_API_BASE_URL;

const css = `
  /* ── EventHeader ── */
  .eventhead { margin: 10px 9px 0; height: 144px; border-radius: 10px; position: relative; overflow: hidden; flex-shrink: 0; }
  .eventhead-bg { position: absolute; inset: 0; background-size: cover; background-position: center; }
  .eventhead-bg::after { content: ""; position: absolute; inset: 0; background: rgba(0,0,0,.5); }
  .eventhead-top { position: relative; z-index: 1; padding: 6px 8px 0; }
  .eventhead-comp { display: flex; align-items: center; gap: 7px; }
  .eventhead-comp .ic { width: 12px; height: 12px; background: #fff; display: inline-block; flex-shrink: 0; }
  .eventhead-comp span { font-size: 12px; font-weight: 600; color: #fff; }
  .eventhead-date { font-size: 10px; color: #ccc; margin: 6px 0 0 0; }
  .eventhead-watch {
    position: absolute; top: 8px; right: 8px; z-index: 2;
    display: flex; align-items: center; gap: 6px; height: 26px; padding: 0 11px;
    border-radius: 13px; background: rgba(0,0,0,.45); box-shadow: inset 0 0 0 1px rgba(118,225,255,.5);
    color: #fff; font-size: 11px; font-weight: 700; border: none; cursor: pointer;
  }
  .eventhead-watch .dot { width: 6px; height: 6px; border-radius: 50%; background: #ff3b3b; flex-shrink: 0; }
  .eventhead-teams {
    position: absolute; left: 0; right: 0; bottom: 0; height: 89px; z-index: 1;
    background: rgba(0,0,0,.5); backdrop-filter: blur(7px);
    padding: 10px 13px; display: flex; flex-direction: column; justify-content: center; gap: 10px;
  }
  .eventhead-team { display: flex; align-items: center; gap: 8px; }
  .eventhead-team img { width: 18px; height: 18px; object-fit: contain; flex-shrink: 0; }
  .eventhead-team-info { display: flex; flex-direction: column; gap: 3px; min-width: 0; }
  .eventhead-team-name { font-size: 12px; font-weight: 600; color: #fff; line-height: 1; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  .eventhead-team-sub { font-size: 10px; color: #aaa; line-height: 1; }
  .eventhead-score { margin-left: auto; font-size: 16px; font-weight: 800; color: #fff; flex-shrink: 0; }
  .eventhead-live { display: inline-flex; align-items: center; gap: 4px; margin-left: auto; font-size: 9px; font-weight: 800; color: #00d4aa; background: rgba(0,212,170,.15); border: 1px solid rgba(0,212,170,.4); border-radius: 20px; padding: 2px 7px; flex-shrink: 0; }
  .eventhead-live-dot { width: 5px; height: 5px; border-radius: 50%; background: #00d4aa; animation: eh-pulse 1.2s ease-in-out infinite; }
  @keyframes eh-pulse { 0%,100%{opacity:1} 50%{opacity:.3} }

  /* ── MarketFilter ── */
  .marketfilter { display: flex; align-items: center; gap: 7px; padding: 12px 12px 2px; overflow-x: auto; flex-shrink: 0; }
  .marketfilter::-webkit-scrollbar { display: none; }
  .mf-search { width: 27px; height: 27px; border-radius: 5px; background: #1d1c3c; display: grid; place-items: center; flex: none; border: none; cursor: pointer; }
  .mf-search .ic { width: 13px; height: 13px; background: #757490; display: block; }
  .mf-chip { flex: none; height: 27px; padding: 0 12px; border-radius: 5px; background: #1d1c3c; color: #fff; font-size: 10px; font-weight: 500; display: flex; align-items: center; gap: 4px; white-space: nowrap; border: none; cursor: pointer; }
  .mf-chip.is-active { background: linear-gradient(82deg, #8187f6 29%, #76e1ff 190%); }
  .mf-chip .count { font-size: 8px; color: #9b9ab0; align-self: flex-start; margin-top: 4px; }
  .mf-chip.is-active .count { color: rgba(255,255,255,.85); }

  /* ── Markets ── */
  .md-markets { padding: 0 0 80px; overflow-y: auto; }
  .market-block { padding: 14px 9px 0; }
  .market-block-head { display: flex; align-items: center; gap: 8px; height: 16px; cursor: pointer; user-select: none; }
  .market-block-head .name { font-size: 11px; font-weight: 500; color: #fff; flex: 1; }
  .market-block-head .chev { width: 11px; height: 11px; background: #757490; transition: transform .2s ease; flex-shrink: 0; }
  .market-block.is-collapsed .chev { transform: rotate(180deg); }
  .market-grid { display: grid; gap: 6px; margin-top: 9px; }
  .market-grid.cols-2 { grid-template-columns: 1fr 1fr; }
  .market-grid.cols-3 { grid-template-columns: 1fr 1fr 1fr; }
  .market-block.is-collapsed .market-grid { display: none; }

  /* ── OddsButton ── */
  .oddsbtn {
    display: flex; align-items: center; justify-content: space-between; gap: 6px;
    height: 34px; border-radius: 5px; background: rgba(29,28,60,.5); padding-left: 8px;
    overflow: hidden; border: none; cursor: pointer; width: 100;
  }
  .oddsbtn.suspended { opacity: .35; cursor: not-allowed; }
  .oddsbtn .obl { font-size: 10px; color: #757490; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; flex: 1; text-align: left; }
  .oddsbtn .obv { min-width: 46px; height: 34px; border-radius: 5px; background: #1d1c3c; display: grid; place-items: center; flex: none; }
  .oddsbtn .obv span { font-size: 11px; font-weight: 500; color: #76e1ff; }
  .oddsbtn.is-selected { box-shadow: inset 0 0 0 1px #76e1ff; background: rgba(118,225,255,.08); }
  .oddsbtn.is-selected .obv { background: linear-gradient(87deg, #8187f6, #76e1ff); }
  .oddsbtn.is-selected .obv span { color: #fff; }

  /* ── Spinner / states ── */
  .md-spinner { display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 80px 20px; gap: 14px; }
  .md-spinner-ring { width: 36px; height: 36px; border: 3px solid rgba(255,255,255,.06); border-top-color: #00d4aa; border-radius: 50%; animation: md-spin 1s linear infinite; }
  @keyframes md-spin { to { transform: rotate(360deg); } }
  .md-spinner p { color: #5a5972; font-size: 13px; margin: 0; }
  .md-not-found { display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 80px 20px; gap: 10px; }
  .md-not-found p { color: #3a3857; font-size: 14px; margin: 0; }
  .md-no-odds { padding: 20px 14px; }
  .md-no-odds p { color: #3a3857; font-size: 12px; margin: 0; }
`;

const FILTER_KEYWORDS = {
  match:     ['winner', 'result', 'double chance', 'draw no bet', 'both teams', 'correct score', 'clean sheet', 'to win'],
  totals:    ['over', 'under', 'total', 'goals', 'corners', 'cards'],
  handicaps: ['handicap', 'asian'],
  halves:    ['half', '1st', '2nd', 'ht/', '/ht', 'halftime'],
  combos:    ['combo', 'scorecast', 'wincast', 'half time/full'],
};

function matchFilter(marketName, filterId) {
  if (filterId === 'all') return true;
  const n = marketName.toLowerCase();
  return (FILTER_KEYWORDS[filterId] || []).some(kw => n.includes(kw));
}

async function loadMatch(sport, id) {
  const res = await fetch(`${API}/api-bet/${sport}/match.php?id=${id}`);
  const data = await res.json();
  if (!data.success) return null;

  if (sport === 'football') {
    const f = data.fixture;
    return {
      id: f.fixture?.id,
      date: f.fixture?.date,
      leagueName: f.league?.name,
      leagueLogo: f.league?.logo,
      homeName: f.teams?.home?.name,
      homeLogo: f.teams?.home?.logo,
      awayName: f.teams?.away?.name,
      awayLogo: f.teams?.away?.logo,
      homeScore: f.goals?.home,
      awayScore: f.goals?.away,
      isLive: f.isLive,
      isFinished: f.isFinished,
      odds: f.odds || [],
    };
  }

  const g = data.game || data.match;
  if (!g) return null;
  return {
    id: g.id,
    date: g.timestamp ? new Date(g.timestamp * 1000).toISOString() : null,
    leagueName: g.league?.name,
    leagueLogo: g.league?.logo,
    homeName: g.teams?.home?.name || g.fighter1,
    homeLogo: g.teams?.home?.logo,
    awayName: g.teams?.away?.name || g.fighter2,
    awayLogo: g.teams?.away?.logo,
    homeScore: g.scores?.home?.total ?? g.goals?.home,
    awayScore: g.scores?.away?.total ?? g.goals?.away,
    isLive: g.isLive || g.status?.short === 'IP',
    isFinished: g.isFinished || ['FT', 'AOT', 'POST', 'Finished'].includes(g.status?.short),
    odds: g.odds || [],
  };
}

function fmtDate(d) {
  if (!d) return '';
  return new Date(d).toLocaleString('fr-FR', { weekday: 'short', day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' });
}

function getGridCols(count) {
  if (count <= 2) return 'cols-2';
  if (count <= 3) return 'cols-3';
  return 'cols-3';
}

export default function MatchDetail() {
  const { t } = useLang();
  const { sport, id } = useParams();
  const navigate = useNavigate();
  const [match, setMatch] = useState(null);
  const [loading, setLoading] = useState(true);
  const [collapsed, setCollapsed] = useState({});
  const [activeFilter, setActiveFilter] = useState('all');
  const [selBets, setSelBets] = useState([]);

  useEffect(() => {
    const sync = () => setSelBets(JSON.parse(localStorage.getItem('betSlipItems') || '[]').map(b => b.id));
    sync();
    window.addEventListener('betAdded', sync);
    return () => window.removeEventListener('betAdded', sync);
  }, []);

  useEffect(() => {
    setLoading(true);
    setMatch(null);
    loadMatch(sport, id)
      .then(m => setMatch(m))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [sport, id]);

  const handleOdd = (bet, value, oddKey) => {
    if (!match || match.isFinished || value.suspended) return;
    const betId = `${id}-${oddKey}`;
    toggleBetSlip({
      id: betId,
      matchId: match.id,
      fixtureId: match.id,
      match: `${match.homeName} vs ${match.awayName}`,
      homeTeam: match.homeName,
      awayTeam: match.awayName,
      date: match.date ? new Date(match.date).toLocaleString('fr-FR') : '',
      fixtureDate: match.date,
      selection: `${bet.name}: ${value.label}`,
      betType: bet.name,
      betLabel: value.label,
      handicap: value.handicap || null,
      odds: parseFloat(value.odd),
      league: match.leagueName,
      isLive: match.isLive || false,
      sport: sport === 'football' ? 'soccer' : sport,
    });
  };

  const toggle = (i) => setCollapsed(p => ({ ...p, [i]: !p[i] }));

  const title = match ? `${match.homeName} vs ${match.awayName}` : (sport || 'Match');

  return (
    <PhoneShell activeTab="sports">
      <style>{css}</style>
      <BackHeader title={title} />

      {loading ? (
        <div className="md-spinner">
          <div className="md-spinner-ring" />
          <p>{t('sports.loadingMatches')}</p>
        </div>
      ) : !match ? (
        <div className="md-not-found">
          <p>{t('sports.matchNotFound')}</p>
          <button style={{ color: '#00d4aa', background: 'none', border: 'none', cursor: 'pointer', fontSize: 13 }} onClick={() => navigate(-1)}>← {t('common.back')}</button>
        </div>
      ) : (
        <>
          {/* ── EventHeader ── */}
          <section className="eventhead">
            <div className="eventhead-bg" style={{ backgroundImage: 'url(/img/event-banner.png)' }} />
            <button className="eventhead-watch">
              <span className="dot" /> {t('home.status.watchLive')}
            </button>
            <div className="eventhead-top">
              <div className="eventhead-comp">
                <span className="ic" style={maskStyle('ic-star')} />
                <span>{match.leagueName || sport}</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <p className="eventhead-date">{fmtDate(match.date)}</p>
                <FavStar
                  item={{
                    id: `${sport}-${id}`,
                    type: 'match',
                    name: `${match.homeName} - ${match.awayName}`,
                    meta: match.leagueName || sport,
                    sport,
                    matchId: id,
                    href: `/match/${sport}/${id}`,
                  }}
                  size={20}
                />
              </div>
            </div>
            <div className="eventhead-teams">
              <div className="eventhead-team">
                {match.homeLogo && <img src={match.homeLogo} alt="" />}
                <div className="eventhead-team-info">
                  <span className="eventhead-team-name">{match.homeName}</span>
                </div>
                {(match.isLive || match.isFinished) && match.homeScore != null ? (
                  <span className="eventhead-score">{match.homeScore}</span>
                ) : match.isLive ? (
                  <span className="eventhead-live"><span className="eventhead-live-dot" />LIVE</span>
                ) : null}
              </div>
              <div className="eventhead-team">
                {match.awayLogo && <img src={match.awayLogo} alt="" />}
                <div className="eventhead-team-info">
                  <span className="eventhead-team-name">{match.awayName}</span>
                </div>
                {(match.isLive || match.isFinished) && match.awayScore != null ? (
                  <span className="eventhead-score">{match.awayScore}</span>
                ) : null}
              </div>
            </div>
          </section>

          {/* ── MarketFilter ── */}
          <div className="marketfilter">
            <button className="mf-search">
              <span className="ic" style={maskStyle('tab-explore')} />
            </button>
            {['all', 'match', 'totals', 'handicaps', 'halves', 'combos'].map(f => {
              const count = f === 'all' ? match.odds.length : match.odds.filter(b => matchFilter(b.name, f)).length;
              if (count === 0) return null;
              const labels = { all: 'All', match: 'Match', totals: 'Totals', handicaps: 'Handicaps', halves: 'Halves', combos: 'Combos' };
              return (
                <button key={f} className={'mf-chip' + (activeFilter === f ? ' is-active' : '')} onClick={() => setActiveFilter(f)}>
                  {labels[f]}
                  {f !== 'all' && <span className="count">{count}</span>}
                </button>
              );
            })}
          </div>

          {/* ── Markets ── */}
          <div className="md-markets">
            {match.isFinished ? (
              <div className="md-no-odds"><p>{t('liveMatch.matchFinishedNoBets')}</p></div>
            ) : match.odds.length === 0 ? (
              <div className="md-no-odds"><p>{t('liveMatch.oddsComingSoon')}</p></div>
            ) : (
              match.odds.filter(b => matchFilter(b.name, activeFilter)).map((bet, i) => (
                <section key={i} className={'market-block' + (collapsed[i] ? ' is-collapsed' : '')}>
                  <div className="market-block-head" onClick={() => toggle(i)}>
                    <span className="name">{bet.name}</span>
                    <svg viewBox="0 0 11 11" fill="none" style={{ width: 11, height: 11, flexShrink: 0 }}>
                      <path d="M4 1h3l-.5 3.2 2 1.8H2.5l2-1.8L4 1zM5.5 6v4" stroke="#757490" strokeWidth="1" strokeLinejoin="round" strokeLinecap="round" />
                    </svg>
                    <span className="chev" style={maskStyle('ic-chevron')} />
                  </div>
                  <div className={'market-grid ' + getGridCols(bet.values.length)}>
                    {bet.values.map((v, vi) => {
                      const hNum = parseFloat(v.handicap);
                      const hStr = !isNaN(hNum) && hNum !== 0 ? (hNum > 0 ? `+${hNum}` : String(hNum)) : null;
                      const label = hStr ? `${v.label} (${hStr})` : v.label;
                      const oddKey = `${bet.name}-${v.label}-${v.handicap || ''}-${vi}`;
                      const betId = `${id}-${oddKey}`;
                      const selected = selBets.includes(betId);
                      return (
                        <button
                          key={vi}
                          className={'oddsbtn' + (selected ? ' is-selected' : '') + (v.suspended ? ' suspended' : '')}
                          onClick={() => handleOdd(bet, v, oddKey)}
                          disabled={!!v.suspended}
                        >
                          <span className="obl">{label}</span>
                          <span className="obv"><span>{v.odd}</span></span>
                        </button>
                      );
                    })}
                  </div>
                </section>
              ))
            )}
          </div>
        </>
      )}
    </PhoneShell>
  );
}
